const TestimonialPopUp = () => {
    return <div className="elfsight-app-fbb0aff2-c681-41f8-92e8-48408eb25ca1" data-elfsight-app-lazy></div>;
}

export default TestimonialPopUp;